import React from 'react';

const PublicContext = React.createContext();

export default PublicContext;